'use strict';

import { initializeApp } from 'firebase/app';

/**
 * Firebase app instance
 */
export const firebaseApp = initializeApp({
  apiKey: 'AIzaSyCvKBh8qM0ZH2Zg_YFcSQNtlF6V8E4FZ5E',
  authDomain: 'flycomps-edc4b.firebaseapp.com',
  projectId: 'flycomps-edc4b',
  storageBucket: 'flycomps-edc4b.appspot.com',
  messagingSenderId: '296485818820',
  appId: '1:296485818820:web:87da080dee9b0d40d39491',
  measurementId: 'G-SVQZ7SNER7',
});
